export const MEASUREMENT_SYSTEM = {
  imperial: 0,
  metric: 1
};

export const MEASUREMENT_SYSTEM_LABEL = {
  [MEASUREMENT_SYSTEM.imperial]: 'Imperial',
  [MEASUREMENT_SYSTEM.metric]: 'Metric'
};
